@if (dialogConfig.data.confirmSubmit==true) {
  <div class="text-center">
    Are you sure you want to submit the below data ?<br>
    <button class="secondary-btn mr-1" type="button" (click)="confirm(false)">{{'button.cancel' | translate | async }}</button>
    @if (dialogConfig?.data?.smbActions!=true) {
      <button class="primary-btn" type="button" (click)="confirm(true)">Confirm</button>
    }
    @if (dialogConfig?.data?.smbActions==true) {
      <button class="primary-btn" type="button" (click)="appendRecords(true)">Append Records</button>
      <button class="primary-btn" type="button" (click)="replaceExistingRecords(true)">Replace Existing Records</button>
    }
  </div>
}


@if (gridInfo.fields && gridInfo.dataFetched==true) {
  <dhs-data-grid [config]="gridInfo.config" [fields]="gridInfo.fields" [data]="gridData" (onPageChanges)="pageChanged($event)" (onLimitChange)="limitChanged($event)"></dhs-data-grid>
}
